export default "__VITE_ASSET__9b8395fe__"